'use client'

import { ChangeEvent, ComponentProps, useEffect, useState } from 'react'

import { Slot } from '@/shared/lib'

import { Input } from './input'
import { Icon } from '../icon'

type Props = Omit<ComponentProps<typeof Input>, 'type'>

export const PasswordField = ({
  value: valueProp,
  onChange: onChangeProp,
  ...props
}: Props) => {
  const [value, setValue] = useState(valueProp ?? '')
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  const editable = !(props.readOnly || props.disabled)

  const handleToggleButtonClick = () => {
    setIsPasswordVisible(!isPasswordVisible)
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value)
    onChangeProp?.(event)
  }

  const handleResetButtonClick = () => {
    setValue('')
    onChangeProp?.({ target: { value: '' } } as ChangeEvent<HTMLInputElement>)
  }

  useEffect(() => {
    if (valueProp !== value) {
      setValue(valueProp ?? '')
    }
  }, [valueProp])

  return (
    <Input
      {...props}
      type={isPasswordVisible ? 'text' : 'password'}
      value={value}
      onChange={handleChange}
    >
      {editable && value && (
        <Slot name="right">
          <div className="flex gap-3">
            <button
              type="button"
              className="cursor-pointer"
              aria-label={
                isPasswordVisible ? '비밀번호 표시 안함' : '비밀번호 표시'
              }
              aria-pressed={isPasswordVisible}
              onClick={handleToggleButtonClick}
              tabIndex={-1}
            >
              <Icon
                name={isPasswordVisible ? 'see-off' : 'see-on'}
                size="24"
                strokeWidth={1.5}
                className="text-black"
              />
            </button>
            <button
              type="button"
              className="cursor-pointer"
              aria-label="텍스트 삭제"
              onClick={handleResetButtonClick}
              tabIndex={-1}
            >
              <Icon
                name="delete"
                size="24"
                strokeWidth={1.5}
                className="text-gray-300"
              />
            </button>
          </div>
        </Slot>
      )}
    </Input>
  )
}
